import { Navigate } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import { useAuth } from '../../contexts/auth-context'

export function AuthGuard({ children }) {
	const { user, loading, roleCheckComplete, pendingPasswordReset } = useAuth()

	// Wait for both initial loading and role check to complete
	if (loading || !roleCheckComplete) {
		return (
			<Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
				<CircularProgress />
			</Box>
		)
	}

	// Redirect to reset-password if the user has a pending password recovery
	if (pendingPasswordReset) {
		return <Navigate to="/reset-password" replace />
	}

	if (!user) {
		return <Navigate to="/auth" replace />
	}

	return children
}
